import React from "react"
import { ArrowLeftIcon } from '@heroicons/react/20/solid'
import { useNavigate } from "react-router-dom"

const PageNotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-row">
      <div className="flex-row-left w-1/2 h-screen">
        <div className="pl-12 flex items-center justify-center mt-10 ">
          <div className="pl-12 w-full max-w-md mt-10">
            <p className="text-sm font-bold text-primary mt-10">401 ERROR</p>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900">
              Unauthorized Access
            </h2>
            <p className="text-gray-600">
              You do not have permission to access this page. Please contact your administrator if you believe this is an error.
            </p>  
            {/* Add buttons for "Go back to home" or "Try to login again" */}
            <div className="flex space-x-4">
              <div className="flex mt-4 font-medium text-primary hover:text-secondary">

                <ArrowLeftIcon className="h-6 w-7 "/>
                <a data-cke-saved-href="/" href="/" className="font-medium text-primary hover:text-secondary pl-2">
                  Go back to home
                </a>
              </div>
              <button
                onClick={() => navigate('/ava-admin/callback')}
                className="flex items-center mt-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-secondary"
              >
                Try to login again
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound